var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiAddonJackOLantern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.726,287.04l0.304,21.019c0.026,2.084-1.53,3.856-3.785,4.107l-20.312,2.3 c-1.235,0.143-2.433-0.197-3.382-0.912c-0.94-0.716-1.504-1.763-1.584-2.899l-1.038-16.374 c-11.292,1.852-22.342,2.774-32.426,2.908c-10.21,0.152-22.164-0.617-34.476-2.362l-0.636,16.831 c-0.036,1.128-0.581,2.183-1.503,2.936c-0.931,0.733-2.157,1.1-3.374,1.002l-20.464-1.718c-2.282-0.188-3.964-1.915-3.99-4 l-0.313-21.403c-20.043-5.7-46.028-14.325-55.27-26.137c-0.618,44.22,18.494,80.352,52.899,104.787 c4.259,3.024,9.288,5.217,14.808,7.302l0.796-12.214c-0.143-1.11,0.269-2.21,1.092-3.042c0.832-0.824,2.004-1.28,3.23-1.253 l18.531,0.358c2.094,0.036,3.838,1.468,4.107,3.364c0,0,0.751,11.802,1.977,19.99c17.403,2.317,36.051,1.994,52.282-1.298 l-1.673-20.007c-0.161-2.058,1.467-3.884,3.722-4.143l18.496-2.148c1.163-0.124,2.317,0.18,3.23,0.85 c0.895,0.672,1.459,1.646,1.548,2.711l1.038,13.207c0.985-0.59,1.71-1.423,2.792-1.844c38.315-14.87,63.144-62.401,60.048-109.824 C361.736,271.927,337.591,280.964,317.726,287.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.686,257.44l-21.663-23.783L234.1,257.092C258.403,263.498,277.686,257.44,277.686,257.44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.972,164.17 134.745,216.406 202.936,231.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "331.748,161.852 300.744,229.944 368.478,213.06  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAddonJackOLantern);
export default __webpack_public_path__ + "static/media/emoji-addon-jack-o-lantern.ba202e223be815ceba8527c5d9bbe18b.svg";
export { ForwardRef as ReactComponent };